export enum Role {
  STUDENT = 'STUDENT',
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  LEKO = 'LEKO',
  SCHUKO = 'SCHUKO',
  EXTERNAL_CONTACT = 'EXTERNAL_CONTACT',
  EXTERNAL_CONTACT_BUT = 'EXTERNAL_CONTACT_BUT',
  EXTERNAL_TEACHER = 'EXTERNAL_TEACHER',
  IKL = 'IKL',
  OSC = 'OSC',
  DKL = 'DiKu',
  PROGRAM_MANAGEMENT = 'PROGRAM_MANAGEMENT',
  ASSISTANT_PROGRAM_MANAGEMENT = 'ASSISTANT_PROGRAM_MANAGEMENT',
  SCHOOL_SUPPORT = 'SCHOOL_SUPPORT',
  LOGISTICS_STAFF = 'LOGISTICS_STAFF',

  INTERNAL_KPF_STRATEGY = 'INTERNAL_KPF_STRATEGY',
  INTERNAL_KPF_OPERATIV = 'INTERNAL_KPF_OPERATIV',
  INTERNAL_KPF_ADMINISTRATION = 'INTERNAL_KPF_ADMINISTRATION',
  INTERNAL_KPF_BUT_OPERATIV = 'INTERNAL_KPF_BUT_OPERATIV',

  // Notification Roles
  NOTIFICATION_REGISTERED_STUDENT = 'NOTIFICATION_REGISTERED_STUDENT',
  NOTIFICATION_REGISTERED_STUDENT_PARTS_BY_MAIL = 'NOTIFICATION_REGISTERED_STUDENT_PARTS_BY_MAIL',
}
